var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getSwRegistration } from 'src/serviceWorkerRegistration';
import config from 'src/system/config';
import { urlB64ToUint8Array } from 'src/utils/webpush';
export function getWebPushSubscription() {
    return __awaiter(this, void 0, void 0, function () {
        var key, swReg, subscription;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // eslint-disable-next-line no-console
                    console.info('Get webpush subscription');
                    key = config.webpushKey;
                    if (!key) {
                        // TODO Do we need to fail here?
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, getSwRegistration()];
                case 1:
                    swReg = _a.sent();
                    if (!swReg) return [3 /*break*/, 5];
                    return [4 /*yield*/, swReg.pushManager.getSubscription()];
                case 2:
                    subscription = _a.sent();
                    if (!!subscription) return [3 /*break*/, 4];
                    // eslint-disable-next-line no-console
                    console.info('No subscription found, creating a new one');
                    return [4 /*yield*/, swReg.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: urlB64ToUint8Array(key),
                        })];
                case 3:
                    subscription = _a.sent();
                    _a.label = 4;
                case 4:
                    // eslint-disable-next-line no-console
                    console.info('Sunscription was obtained');
                    return [2 /*return*/, subscription];
                case 5:
                    // eslint-disable-next-line no-console
                    console.info('No service worker registration found');
                    return [2 /*return*/, null];
            }
        });
    });
}
export function unsubscribeWebPush() {
    return __awaiter(this, void 0, void 0, function () {
        var registration, subscription, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // eslint-disable-next-line no-console
                    console.info('Unsubscribing from webpush');
                    localStorage.removeItem('notification');
                    return [4 /*yield*/, getSwRegistration()];
                case 1:
                    registration = _a.sent();
                    if (!registration) return [3 /*break*/, 7];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 6, , 7]);
                    return [4 /*yield*/, registration.pushManager.getSubscription()];
                case 3:
                    subscription = _a.sent();
                    if (!subscription) return [3 /*break*/, 5];
                    return [4 /*yield*/, subscription.unsubscribe()];
                case 4: return [2 /*return*/, _a.sent()];
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error('Error unsubscribing', error_1);
                    return [2 /*return*/, false];
                case 7: return [2 /*return*/, null];
            }
        });
    });
}
